<script>
    import {onMount} from "svelte";

    export let value = '';
    export let label;
    export let options = [];
    export let isDisabled = false;
    export let name = '';
    let fill = false;
    let focus = false;
    export let icon = null;
    export let iconFamily = 'fal';

    onMount(() => {
        setStatus();
    });

    function setStatus() {
        focus = false;
    }
</script>
<div class="naui-field active w-100">
    <div class="naui-field-back" class:fill={fill}>
        <label class:focus={focus}>{label}</label>
        <select {name} class="naui-input w-100" bind:value={value}
                on:focusin={()=>focus=false} on:change disabled={isDisabled}>
            <option value="" hidden>{label}</option>
            {#each options as option, i}
                {#if option}
                    {#if option.options}
                        <optgroup label={option.name}>
                            {#each option.options as sub}
                            <option value={sub.value}>{sub.label}</option>
                            {/each}
                        </optgroup>
                    {:else}
                        <option value="{option.value}">{option.label}</option>
                    {/if}
                {/if}
            {/each}
        </select>
    </div>
    {#if icon}
        <i class="{iconFamily} fa-{icon} icon"></i>
    {/if}
</div>
<style>
    select {
        font-size: .95rem;
    }
    .naui-field-back.fill{
        background: white;
    }
    .icon{
        position: absolute;
        right:.5rem;
        top:1.3rem;
        font-size: 1.1rem;
        color: var(--secondary);
    }
</style>
